import { trackCxFoundationsTopicCsatClick } from "@faire/web-api/events/cxFoundations/click/topicCsat";
import React from "react";
import { CsatCollected } from "./CsatCollected";
import { CsatQuestion } from "./CsatQuestion";
export var Csat = function Csat(_ref) {
  var feedbackCollectedByIssueType = _ref.feedbackCollectedByIssueType,
    issueType = _ref.issueType,
    setFeedbackCollected = _ref.setFeedbackCollected;
  var handleFeedbackClick = function handleFeedbackClick(feedback) {
    trackCxFoundationsTopicCsatClick(issueType, feedback);
    setFeedbackCollected(issueType, true);
  };
  var wasCsatCollected = feedbackCollectedByIssueType[issueType];
  if (wasCsatCollected) {
    return /*#__PURE__*/React.createElement(CsatCollected, null);
  }
  return /*#__PURE__*/React.createElement(CsatQuestion, {
    handleYesClick: function handleYesClick() {
      return handleFeedbackClick("Yes");
    },
    handleNoClick: function handleNoClick() {
      return handleFeedbackClick("No");
    }
  });
};